import type { PatentValuationExtend } from '../types';

export interface GetPatentValuationDTO {
    getPatentValuation(valuation: number, patentType: string[]): PatentValuationExtend;
}

export const GetPatentValuationDTO = Symbol.for('GetPatentValuationDTO');
